module.exports = __webpack_public_path__ + "img/set1.adbe5cae.png";